import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


const header = "Kite Mode:";
const handleFunc = (isActive: boolean) => eventBus.emit(EnumEventBus.KiteMode, isActive)
const coords = {
	vertical: { x: -160, y: 550 },
	horizontal: { x: 100, y: 320 }
}


export default class KiteSwitcher extends SwitcherContainer {
	constructor() {
		super({ header, coords, handleFunc });

		eventBus.on(EnumEventBus.Triangle1Mode, (v: boolean) => this.setActivation(v));
		eventBus.on(EnumEventBus.Triangle2Mode, (v: boolean) => this.setActivation(v));
	}
	
	setActivation(v: boolean) {
		if (v) {
			const isActive = this.Switcher.getActive();
			if (isActive) {
				this.Switcher.handleSwitcherOff();
			}
		}
	}
}